import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.scss'],
    standalone: false
})
export class PublicComponent implements OnInit {

  date = Date.now();

  constructor() { }

  ngOnInit(): void {
  }

}
